import React from "react";
import { render } from "react-dom";
import VincitSurvey from "./js/components/VincitSurvey";
const css = require('./style.css');
const radar = require('svg-radar-chart');
const stringify = require('virtual-dom-stringify');

//output form
const app = document.querySelector('#vincitsurvey');

if (app){
  const formid = app.dataset && app.dataset.formid ? app.dataset.formid : "1";
  const form = app.dataset && app.dataset.form ? app.dataset.form : null;
  const url = app.dataset && app.dataset.url ? app.dataset.url : null;

  render(
    <VincitSurvey formid={formid} url={url} form={form} />,
    app
  );
  // empty form
  app.dataset.form = "";
  app.dataset.url = "";
}

//Draw chart
const vincitchart = document.querySelector('#vincitchart-data');
if (vincitchart){
  const labels = vincitchart.dataset && vincitchart.dataset.labels ? vincitchart.dataset.labels : {};
  const results = vincitchart.dataset && vincitchart.dataset.results ? vincitchart.dataset.results : {};
  const active = vincitchart.dataset && vincitchart.dataset.active ? vincitchart.dataset.active : '';
  const parsed_labels = JSON.parse(labels);
  const parsed_results = JSON.parse(results);

  const defaults = {
	size: 100, // size of the chart (including captions)
	axes: true, // show axes?
	scales: 6, // show scale circles?
	captions: true, // show captions?
	captionsPosition: 1.6, // where on the axes are the captions?
	axisProps: () => ({className: 'axis'}),
	scaleProps: () => ({className: 'scale', fill: 'none'}),
	shapeProps: () => ({className: 'shape'}),
	captionProps: (col) => ({
		className: 'caption ' + col.key,
		textAnchor: 'middle', fontSize: 4,
		fontFamily: 'Proxima Nova'
  })
};

  const chart = radar(parsed_labels, [parsed_results], defaults);

  const svg = (`
<svg version="1" xmlns="http://www.w3.org/2000/svg" width="500" height="500" viewBox="0 0 100 100">
	<style>
		.axis {
			stroke: #4F4F4F;
			stroke-width: .2;
		}
		.scale {
			fill: transparent;
			stroke: #E4E4E4;
			stroke-width: .2;
		}
		.shape {
			fill-opacity: .85;
			stroke-width: .5;
      fill: #193D6F;
      stroke: #193D6F;
		}
    .caption {
      fill: #193D6F;
      font-weight: 800;
    }
		.shape:hover { fill-opacity: .7; fill: #193D6F; stroke: #193D6F; }
	</style>
	${stringify(chart)}
</svg>
`);
document.querySelector('#vincitchart-wrap').innerHTML = svg;


Object.keys(parsed_labels).forEach((item, key) => {
  const itemid = "text.caption." + item;
  const elem = document.querySelector(itemid);
  if (elem){
    if (item === active){
      elem.classList.add('active');
    }
      elem.addEventListener("click", (e) => {
        //Add active to caption
        Array.from(elem.parentElement.children).forEach((echild, i) => {
          echild.classList.remove('active');
        });
        elem.classList.add('active');
        elem.scrollIntoView({behavior: "smooth"});

        //Add active to desc
        const activeItem = document.querySelector("div#"+item);

        if (activeItem) {
          Array.from(activeItem.parentElement.children).forEach((child, i) => {
            child.classList.remove('active');
          });
          activeItem.classList.add('active');
        }
      })
    }
});

}
const vincitsurvey = document.querySelector('.vincitsurvey.content-wrap');
if (vincitsurvey){
// store entryid
    let entryidStored = window.localStorage.getItem('entryid');

    if (entryidStored){
      if(isNaN(parseInt(entryidStored))){
        // corrupted id
        window.localStorage.removeItem('entryid');
      }
      else {
        // valid entryid
        const backMenu = document.querySelector(".survey-menu li.back");
        if (backMenu) {
          backMenu.classList.add('show');
          const oldHref = backMenu.querySelector('a').href.split('?')[0];
          backMenu.querySelector('a').href = oldHref + "?entryid=" + entryidStored;
        }
      }
    }
  const reportTemplate = document.querySelector('.page-template-results-full-template');
  const resultsTemplate = document.querySelector('.page-template-results-template');
  if (reportTemplate || resultsTemplate){
      //entryidStored = window.localStorage.getItem('entryid');
      //if (!entryidStored){
        // no stored entry id
        const params = window.location.search;
        if (params){
          const urlParams = new URLSearchParams(params);
          const entryidParam = urlParams.get('entryid');

          if ( entryidParam && !isNaN(parseInt(entryidParam)) ) {
            window.localStorage.setItem('entryid', entryidParam);
          }
        }
      //}
  }
}

